module.exports = function() {
  return new Worker(__webpack_public_path__ + "d326409aff0f61cad368.worker.js");
};